export default "__VITE_ASSET__CGaMN_hR__"